import store from "@/store/store";

export default [
    {
        path: '/:subject(social\\-studies)/:state?/:grade(-1|k|K|0|1|2|3|4|5|6|7|8)?/:language(en|es)?',
        name: 'social-studies',
        component: () => import('@/views/products/SocialStudies.vue'),
        props: true,
        meta: {
            title: 'Studies Weekly Store - Social Studies',
        }
    },
    {
        path: '/:subject(well\\-being)/:state?/:grade(-1|k|K|0|1|2|3|4|5|6|7|8)?/:language(en|es)?/:version(free|full)?',
        name: 'well-being',
        component: () => import('@/views/products/WellBeing.vue'),
        props: true,
        meta: {
            title: 'Studies Weekly Store - Well-Being',
        }
    },
    {
        path: '/:subject(health)/:state?/:grade(-1|k|K|0|1|2|3|4|5|6|7|8)?/:language(en|es)?/:version(free|full)?',
        name: 'health',
        component: () => import('@/views/products/HealthAndWellness.vue'),
        props: true,
        meta: {
            title: 'Studies Weekly Store - Health & Wellness',
        }
    },
    {
        path: '/:subject(national\\-social\\-studies)/:state?/:grade(-1|k|K|0|1|2|3|4|5|6|7|8)?/:language(en|es)?',
        name: 'national-social-studies',
        component: () => import('@/views/products/NationalSocialStudies.vue'),
        props: true,
        meta: {
            title: 'Studies Weekly Store - National Social Studies',
        }
    },
    {
        path: '/:subject(science)/:state?/:grade(-1|k|K|0|1|2|3|4|5|6|7|8)?/:language(en|es)?',
        name: 'science',
        component: () => import('@/views/products/Science.vue'),
        props: true,
        meta: {
            title: 'Studies Weekly Store - Science',
        }
    },
    {
        path: '/science2/:state?/:grade(-1|k|K|0|1|2|3|4|5|6|7|8)?/:language(en|es)?',
        name: 'science2',
        component: () => import('@/views/products/ExploreScience.vue'),
        props: true,
        meta: {
            title: 'Studies Weekly Store - Science',
        },
    },

    {
        path: '/:subject(summer\\-school)/:state?/:grade(k|K|0|1|2|3|4|5|6|7|8)?/:language(en|es)?',
        name: 'summer-school',
        component: () => import('@/views/products/SummerSchool.vue'),
        props: true,
        meta: {
            title: 'Studies Weekly Store - General Education',
        }
    },
    {
        path: '/:subject(pre\\-k)/:state?/:grade(k|K|-1|0|1|2|3|4|5|6|7|8)?/:language(en|es)?',
        name: 'pre-k',
        component: () => import('@/views/products/PreK.vue'),
        props: true,
        meta: {
            title: 'Studies Weekly Store - Character Education',
        }
    },

    {
        path: '/product/:sku',
        component: () => import('@/views/products/BurritoProducts.vue'),
        name: 'burrito-products',
        props: true,
        meta: {
            title: 'Studies Weekly Store'
        }
    },
    {
        path: '/positive-outlook-poster',
        component: () => import('@/views/products/WBPoster.vue'),
        name: 'wb-poster',
        meta: {
            title: 'Studies Weekly Store - Positive Outlook Poster'
        }
    },
    {
        path: '/civil-rights/:sku?',
        component: () => import('@/views/products/BurritoProducts.vue'),
        name: 'civil-rights',
        props: true,
        meta: {
            title: 'Studies Weekly Store'
        }
    },
    {
        path: '/pages/:pageId/:state?/:grade(-1|k|K|0|1|2|3|4|5|6|7|8)?/:language(en|es)?/',
        name: 'dynamic-page',
        component: () => import('@/views/products/DynamicProductPage.vue'),
        props: true,
    },
    {
        path: '/n-social-studies/:state?/:grade(-1|k|K|0|1|2|3|4|5|6|7|8)?/:language(en|es)?',
        name: 'n-social-studies',
        alias: 'new-social-studies',
        component: () => import('@/views/products/AdoptedSocialStudies.vue'),
        props: true,
        meta: {
            title: 'Studies Weekly Store - Social Studies',
            props: {
                subject: 'social-studies',
            }
        }
    },

];